const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_API_KEY || '';

const request = async (method, path, { params, body } = {}) => {
  let url = `${API_BASE}/admin${path}`;
  if (params && Object.keys(params).length > 0) {
    url += '?' + new URLSearchParams(params).toString();
  }

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'x-admin-token': ADMIN_TOKEN,
    },
  };
  if (body !== undefined) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || data.message || 'Request failed');
  }
  return data;
};

export const adminApi = {
  getOrders: (params) => request('GET', '/orders', { params }),
  getOrderDetails: (id) => request('GET', `/orders/${id}`),
  assignPartner: (orderId, partnerId) =>
    request('PUT', `/orders/${orderId}/assign-partner`, { body: { partner_id: partnerId } }),
  removePartner: (orderId) => request('PUT', `/orders/${orderId}/remove-partner`),
  cancelOrder: (orderId) => request('PUT', `/orders/${orderId}/cancel`),
  updateOrder: (orderId, data) => request('PUT', `/orders/${orderId}`, { body: data }),
  getPartners: (params) => request('GET', '/partners', { params }),
};
